import { useRef, useState } from 'react'
import { useGetContainers } from '../useGetContainers'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { string } from 'prop-types'
import { useDeleteEgo } from '../useDeleteEgo'

interface getContainersListParams {
  pageNo?: number
}

export const useMediaUploadsViewModel = () => {
  const getContainersHook = useGetContainers()
  const deleteEgos = useDeleteEgo('topicID')
  const [loadingNextPage, setLoadingNextPage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState<any>()
  const [canLoadNextPage, setCanLoadNextPage] = useState(false)
  const { setMyContainers } = useAppStore()
  const [myContainers] = useAppStore((state) => [state.user.myContainers], shallow)

  let paramsRef = useRef<getContainersListParams | null>(null)
  const getContainersList = async (params: getContainersListParams) => {
    const { pageNo = 1 } = params
    paramsRef.current = params
    if (pageNo == 1) setLoading(true)
    else setLoadingNextPage(true)

    await getContainersHook.mutateAsync(pageNo)
    setLoading(false)
    setLoadingNextPage(false)

    // TODO: parse pagination object also from getContainers
    // setPagination
    // setCanLoadNextPage
  }

  // Load Next Page Data
  const loadNextPageData = () => {
    if (paramsRef.current != null && canLoadNextPage) {
      getContainersList({ ...paramsRef.current, pageNo: (paramsRef.current.pageNo || 1) + 1 })
    }
  }

  const deleteEgoObjects = (containerID: string, egoIDs: string[]) => {
    // update container list with count
    const filtered = myContainers.map((e) => ({
      ...e,
      photoCount:
        e.containerID == containerID ? `${Number(e.photoCount) - egoIDs.length}` : e.photoCount,
    }))
    setMyContainers(filtered)
    return deleteEgos.mutateAsync(egoIDs)
  }

  return {
    loading,
    loadingNextPage,
    canLoadNextPage,
    containers: myContainers,
    getContainersList,
    loadNextPageData,
    pagination,
    deleteEgoObjects,
  }
}
